import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Registers the service worker purely as a progressive enhancement: asset
 * caching and offline support for cached content. If the SW fails for any
 * reason, the app continues working normally.
 *
 * It deliberately does NOT auto-apply updates or reload the page. Reloading is
 * owned entirely by useVersionCheck, which shows a persistent "Update
 * available" toast and lets the user pick the moment. When they accept,
 * forceReloadForUpdate unregisters the worker and clears caches, so the new
 * build is always picked up — we never need to silently skipWaiting here.
 *
 * The config uses registerType 'prompt' with no skipWaiting/clientsClaim, so a
 * waiting worker simply waits. Auto-applying (the old autoUpdate + skipWaiting
 * config) makes the worker take control and fires an immediate reload that
 * interrupts whatever the user is doing mid-task.
 */
export function PWAUpdatePrompt() {
  useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) {
        return;
      }

      // Refresh the registration hourly so a new build precaches in the
      // background. This never reloads on its own — only a skipWaiting message
      // would, and we don't send one.
      setInterval(
        () => {
          registration.update().catch(() => {
            // Network hiccups must not surface to the user.
          });
        },
        60 * 60 * 1000
      );
    },
    onRegisterError() {
      // SW is an enhancement, not a requirement — fail silently.
    },
  });

  return null;
}
